import { MAX_ACTIVE_GROUP_MEMBERS_NUMBER } from '@smarty-nx/code-utils'

import { ModalType } from './index.types'

export type ModalTypeContent = {
  title: string
  details: string
}

export type GroupModalContent = {
  contentByUserType: Record<ModalType, ModalTypeContent>
  cta: string
}

export const content: GroupModalContent = {
  contentByUserType: {
    [ModalType.GROUP_OWNER_INACTIVE]: {
      title: 'Your plan is currently inactive.',
      details: 'You must activate your plan before adding group members.',
    },
    [ModalType.FULL_GROUP]: {
      title: `Your group has reached the maximum limit of ${
        MAX_ACTIVE_GROUP_MEMBERS_NUMBER + 1
      } members.`,
      details:
        'To add a new member, please remove someone from the group first.',
    },
    [ModalType.ALREADY_IN_GROUP]: {
      title: "You're already part of a Group plan!",
      details: 'You can’t join another Group plan or start your own right now.',
    },
  },
  cta: 'Help and Support',
}
